<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="incidentTabsInEventForm">
      <div class="">
        <h3 class="form_name">Incident-Tabs InEvent</h3>

        <div class="input">
          <label for="">Incident Tab</label>
          <select class="default_input reference-form" formControlName="IncidentTabsId" (change)="onSelectTabs($event.target.value)" #eventTab style="width: 100%">
              <option value=""> Select Incident Tab </option>
                  <option *ngFor="let eventTab of incidentTabs"  [value]="eventTab.id">
                   {{eventTab.TabName}}
                  </option>
          </select>
        </div>

        <div class="input">
          <div class="input">
            <label for="">Position</label>
            <input type="number" class="default_input reference-form" formControlName="Position" />
                    
          </div>
        </div>

      

        <div class="btn_holder">
          <button
            class="default_primary-button"
            *ngIf="selectedIndex === null"
            (click)="addNew(incidentTabsInEventForm.value)"
          >
            Add
          </button>
          <button
            class="default_primary-button"
            *ngIf="selectedIndex !== null"
            (click)="addNew(incidentTabsInEventForm.value)"
          >
            Update
          </button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">
            Reset
          </button>
        </div>
      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input
          type="text"
          class="default_input search"
          placeholder="Search for ItemType"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="eventTypes | filterReference: control.value as result"
            >
              <app-option
                (click)="onSelectEventType(option.id)"
                *ngFor="let option of result"
                [value]="option.EventName"
              >
                {{ option.EventName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Event Tab</span>
        <span class="item">Position</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll"></div>
    
      <div class="body_content" *ngIf="status">
        <div class="the_body"
        *ngFor="let incidentTabsInEvent of incidentTabsInEventFormArray.get('IncidentTabsInEvents')['controls']; index as i"
        (click)="onEdit(i, incidentTabsInEvent.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{getTabName(incidentTabsInEvent.value.IncidentTabsId)}}</span>          
          <span class="content">{{incidentTabsInEvent.value.Position}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"

            (click)="deleteIncidentTabsInEvent(i, incidentTabsInEvent.value)">
            <em class="ti-trash"> </em> </button>
          </span>

        </div>
        </div>
      <div class="btn_holder">
        <button
          class="default_primary-button"
          (click)="onSubmit(incidentTabsInEventFormArray.value)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>

